import * as yup from 'yup';

type LoginFormSchemaParams = {
  isRelogin?: boolean;
};

const schema = ({ isRelogin = false }: LoginFormSchemaParams) => ({
  username: yup
    .string()
    .label(`login_form_username${!isRelogin ? 'SuperAdmin' : ''}_label`)
    .required(),
  isLoginSubAccount: yup.boolean(),
  subAccountUsername: yup
    .string()
    .label('common_sub_account')
    .when('isLoginSubAccount', {
      is: true,
      then: (schema: yup.StringSchema) => schema.required(),
    }),
  password: yup.string().label('common_password').required(),
});

export const loginFormSchema = (params: LoginFormSchemaParams = {}) =>
  yup.object(schema(params)).required();

const defaultLoginFormSchema = loginFormSchema();

export type LoginFormData = yup.InferType<typeof defaultLoginFormSchema>;
